export const GOT_IT_CUE = 'Next_cue_last_';
export const NEXT_CUE = 'Next_cue_';
export const COACHMARK_EXPIRY = 'coachmarkExpiry';
export const SHOW = 'show';
export const RESET_EXPIRY = 'resetExpiry';
export const HIDE = 'hide';
export const BTN_NEXT_TEXT = 'NEXT';
export const BTN_GOT_IT_TEXT = 'GOT IT';
export const BTN_SKIP_TEXT = 'SKIP';
export const PAGE_NAME_LIST = {
  LISTING: 'listing',
  DETAILS: 'details',
  PSM: 'psm',
  PSM_MODIFY: 'psmModify',
  LISTINGV3: 'listingV3',
};
export const BTN_NAME_LIST = { GOT_IT: 'gotIt', OVERLAY: 'Overlay', SKIP: 'Skip' };
export const COACHMARK_STATE = { SHOW, HIDE, RESET_EXPIRY };
export const VISITED_COACHMARK = 'visitedCoachmark';
export const CLOSE_COACHMARK_CLICKED = 'CLOSE_COACHMARK_CLICKED';
